import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425e99f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewDefaultLayout__container" }
const _hoisted_2 = { class: "container__view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_new_header = _resolveComponent("new-header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["NewDefaultLayout", { 'NewDefaultLayout--closed': !_ctx.store.is_sidebar_opened }])
  }, [
    _createVNode(_component_sidebar, {
      "is-opened": _ctx.store.is_sidebar_opened,
      onToggle: _ctx.store.toggleSidebar
    }, null, 8, ["is-opened", "onToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_header, { "without-sectors": _ctx.withoutSectors }, null, 8, ["without-sectors"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 2))
}